import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import backlogo from '../../Assets/App_icon/back.png';
import gmaplogo from '../../Assets/App_icon/gmap.png';

const CustomerMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');
  const user_role = localStorage.getItem('user_role');

  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 
  const [addmodalVisible, setAddModalVisible] = useState(false); 
  const [ledgerModalVisible, setLedgerModalVisible] = useState(false); 
  const [salesDetailModalVisible, setSalesDetailModalVisible] = useState(false); 
  
  const [areas, setAreas] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [ledgerData, setLedgerData] = useState([]);
  const [selectedLedgerData, setSelectedLedgerData] = useState([]);
  const [selectedSalesDetail, setSelectedSalesDetail] = useState([]);

  const [addCustMo, setAddCustMo] = useState('');
  const [addCustEName, setAddCustEName] = useState('');
  const [addCustName, setAddCustName] = useState('');
  const [addCustEAdd, setAddCustEAdd] = useState('');
  const [addCustAdd, setAddCustAdd] = useState('');
  const [addCustRefno, setAddCustRefno] = useState('');
  const [addCustAreaID, setAddCustAreaId] = useState('');
  

  const handleBack = () => {
    navigate('../dashboard');
  };

    useEffect(() => { 
      const fetchAreaList = async () => { 
          
          try {
            const response = await fetch(`${host_url}/area_list`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                areaId : '',
                areaName: '',
                areaEName: '',
              }),
            });
            const data = await response.json();
            setAreas(data);
            setAddCustAreaId(data[0].areaId);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
      }; 
     fetchAreaList(); 
    }, [host_url, store, customers]);


    // Escape key press handling
    useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          // Close modal or navigate back if no modal is open
          if (modalVisible || ledgerModalVisible || salesDetailModalVisible) {
            if(salesDetailModalVisible) {
              setSalesDetailModalVisible(false);
              setLedgerModalVisible(true);
            }else {
              setModalVisible(false);
              setLedgerModalVisible(false);
            }
            
          } else {
            handleBack();
          }
        }
        
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible, ledgerModalVisible, salesDetailModalVisible]);

    useEffect(() => { 
      const fetchCustList = async () => { 
          try {
            const response = await fetch(`${host_url}/cust_mlist`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                custId: '',
                custMo: '',
                custName: '',
                custEName: '',
                custAreaId: '',
                custAdd: '',
                custEAdd: '',
                custVerify: '',
                custRefno: '', 
              }),
            });
            const data = await response.json();
            setCustomers(data);
            console.log(data);
          } catch (error) {
            console.error('Error fetching cities:', error);
          }
          
      }; 
     fetchCustList(); 
    }, [host_url, store]);

    
    const [custIdFilter, setCustIdFilter] = useState('');
    const [custMoFilter, setCustMoFilter] = useState('');
    const [custNameFilter, setCustNameFilter] = useState('');
    const [custEAddFilter, setCustEAddFilter] = useState('');
    const [custAreaFilter, setCustAreaFilter] = useState('');
    const [custStatusFilter, setCustStatusFilter] = useState('');

    const [balOperator, setBalOperator] = useState('');
    const [balValue, setBalValue] = useState('');

    const parseNum = v => {
      if (v === null || v === undefined) return null;
      const s = String(v).trim();
      if (s === "") return null;
      const n = Number(s);
      return Number.isFinite(n) ? n : null;
    };

    const applyOperator = (actual, op, value) => {
      // value assumed numeric (or null)
      if (op === '' || value === null) return true; // no operator/value => allow
      switch (op) {
        case '>':  return actual > value;
        case '>=': return actual >= value;
        case '<':  return actual < value;
        case '<=': return actual <= value;
        case '=':  return actual === value;
        case '!=': return actual !== value;
        default:   return true;
      }
    };

    

    const filteredCustomers = customers.filter(c => {
      // safe lowercase helper
      const safeLower = v => (v === null || v === undefined) ? "" : String(v).toLowerCase();

      // TEXT FILTERS (quick fail)
      if (!String(c.custId || '').toLowerCase().includes(custIdFilter.toLowerCase())) return false;
      if (!String(c.custMo || '').toLowerCase().includes(custMoFilter.toLowerCase())) return false;
      if (
            !(
              String(c.custEName || '').toLowerCase().includes(custNameFilter.toLowerCase()) ||
              String(c.custName || '').toLowerCase().includes(custNameFilter.toLowerCase())
            )
          ) return false;
      if (
            !(
              String(c.custEAdd || '').toLowerCase().includes(custEAddFilter.toLowerCase()) ||
              String(c.custAdd || '').toLowerCase().includes(custEAddFilter.toLowerCase())
            )
          ) return false;
      if (!String(c.custAreaEName || '').toLowerCase().includes(custAreaFilter.toLowerCase())) return false;
      if (!String(c.custVerify || '').toLowerCase().includes(custStatusFilter.toLowerCase())) return false;

      // BALANCE parsing
      const balance = Number(c.custBalance);
      if (!Number.isFinite(balance)) {
        // exclude non-numeric balances — change to `return true` if you prefer to include them
        return false;
      }

      // APPLY OPERATOR FILTER (if operator selected)
      const parsedBalValue = parseNum(balValue); // will be null if empty or invalid
      if (balOperator && parsedBalValue !== null) {
        if (!applyOperator(balance, balOperator, parsedBalValue)) return false;
      }
      return true;
    });


    const totalCount = filteredCustomers.length;
    const totalBalance = filteredCustomers.reduce((sum, customer) => sum + (customer.custBalance ?? 0), 0);
    const detailtotalWeight = selectedSalesDetail.reduce((sum, product) => sum + Number(product.sd_prd_qty), 0);
    const detailtotalAmt = selectedSalesDetail.reduce((sum, product) => sum + Number(product.sd_prd_amt), 0);


    const handleCustDetail = (cust) => {
      setModalVisible(true);
      setSelectedCustomer(cust);
    };

    // Functions for handling the different actions
    const handleAddCust = async () => {
      setAddModalVisible(false);
      try {
        const response = await fetch(`${host_url}/cust_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'insert',
            store: store,
            custId: '', 
            custMo: addCustMo,
            custName: addCustName, 
            custEName: addCustEName, 
            custAreaId: addCustAreaID, 
            custAdd: addCustAdd, 
            custEAdd: addCustEAdd,  
            custRefno: addCustRefno || 0,
            custLocStatus: 'N',
          }),
        });
        const data = await response.json();
        setCustomers(data);
        let newCustId = data.find(item => String(item.custMo) === String(addCustMo))?.custId;
        handleAddMainCust(newCustId, addCustMo);       
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleAddMainCust = async (newCustId, mobileNumber) => {
      let cityId = String(newCustId).substring(0, 2);
      try {
        const response = await fetch(`https://backend.veryfreshmain.in/api/cust_add_main`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            custId: newCustId,
            mobileNumber: mobileNumber,
            lang: 'Gujarati', 
            cityId: cityId, 
          }),
        });
        await response.json(); 
          setAddCustMo('');
          setAddCustRefno('');
          setAddCustEName('');
          setAddCustName('');
          setAddCustEAdd('');
          setAddCustAdd(''); 
          setAddCustAreaId('');
      } catch (error) {
        console.error('Error fetching cust_add_main:', error);
      }    
    };

    const handleUpdateCust = async () => {
      setModalVisible(false);
      const selectedArea = areas.find(area => area.areaEName === selectedCustomer.custAreaEName);
      const selectedAreaId = selectedArea ? selectedArea.areaId : null;

      try {
        const response = await fetch(`${host_url}/cust_mlist`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'update', 
            store: store, 
            custId: selectedCustomer.custId, 
            custMo: selectedCustomer.custMo,
            custName: selectedCustomer.custName, 
            custEName: selectedCustomer.custEName, 
            custAreaId: selectedAreaId , 
            custAdd: selectedCustomer.custAdd, 
            custEAdd: selectedCustomer.custEAdd ,  
            custRefno: selectedCustomer.custRefno || 0,
            custLocStatus: selectedCustomer.custLocStatus, 
          }),
        });
        const data = await response.json();
        setCustomers(data);
        let newCustId = data.find(item => String(item.custMo) === String(selectedCustomer.custMo))?.custId;
        if(String(newCustId) !== String(selectedCustomer.custId)){
            handleUpdateMainCust(selectedCustomer.custId, newCustId);
        }
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleUpdateMainCust = async (custId, newCustId) => {
      try {
        const response = await fetch(`https://backend.veryfreshmain.in/cust_update_main`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            custId: custId,
            newCustId: newCustId ,
            lang: 'Gujarati' 
          }),
        });
        await response.json(); 
      } catch (error) {
        console.error('Error fetching cust_add_main:', error);
      }
    };

    const handleCustLedger = async (cust) => {
      setLedgerModalVisible(true);
      setSelectedCustomer(cust);
      try {
        const response = await fetch(`${host_url}/cust_ledger`, {
        method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            custId: cust.custId,
            lang: 'Gujarati',
            store: store
          }),
        });

        const data = await response.json();
        setLedgerData(data);
        console.log("Ledger Data : ",data);
      } catch (error) {
        console.error('Error updating profile:', error);
      }
    };

    const handleSalesDetail = async (sale) => {

      setSalesDetailModalVisible(true);
      setLedgerModalVisible(false);
      setSelectedSalesDetail([]);
      setSelectedLedgerData(sale);
      const salesDetail = {
            sl_id: sale.tr_id,
        };
      try {
        const response = await fetch(`${host_url}/sales_select`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'list', 
            store: store, 
            salesdetail: salesDetail,  
          }),
        });
        const data = await response.json();
        setSelectedSalesDetail(data);
        console.log("selectedSalesDetail", data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }  
    };

  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Customer Master</b>
              <div ></div>
          </div>
         
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >
                <th>Cust Id</th>
                <th>Mobile</th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={custEAddFilter}
                    onChange={(e) => setCustEAddFilter(e.target.value)}
                    placeholder="Search By Address"
                  />
                </th>
                <th colSpan='2'>Area</th>
                <th>verify</th>
                <th>Balance</th>
              </tr>
              <tr>
                 <th>
                  <input
                    type="text"
                    className="search-input"
                    value={custIdFilter}
                    onChange={(e) => setCustIdFilter(e.target.value)}
                  />
                </th>
                <th>
                  <input
                    type="text"
                    className="search-input"
                    value={custMoFilter}
                    onChange={(e) => setCustMoFilter(e.target.value)}
                  />
                </th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={custNameFilter}
                    onChange={(e) => setCustNameFilter(e.target.value)}
                    placeholder="Search By Name"
                  />
                </th>
                <th colSpan='2'>
                  <select
                    className="search-input"
                    value={custAreaFilter}
                    onChange={(e) => setCustAreaFilter(e.target.value)}
                  >
                    <option value="">All Status</option>
                    {areas.map((area) => (
                      area.customer > 0 && (
                        <option key={area.areaId} value={area.areaEName}>
                          {area.areaEName}
                        </option>
                      )
                    ))}
                  </select>
                </th>
                <th>
                  <select
                    className="search-input"
                    value={custStatusFilter}
                    onChange={(e) => setCustStatusFilter(e.target.value)}
                  >
                    <option value="">All Status</option>
                    <option value="Y">Complete</option>
                    <option value="N">Panding</option>
                  </select>
                </th>
                <th> 
                  <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                    <select
                      className="search-input"
                      style={{ width: '45%' }}
                      value={balOperator}
                      onChange={(e) => setBalOperator(e.target.value)}
                    >
                      <option value="">All</option>
                      <option value=">">{'>'}</option>
                      <option value="<">{'<'}</option>
                      <option value=">=">{'>='}</option>
                      <option value="<=">{'<='}</option>
                      <option value="=">{'='}</option>
                      <option value="!=">{'!='}</option>
                    </select>

                    <input
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9\-\.]*"
                      className="search-input"
                      style={{ width: '40%', textAlign: 'center' }}
                      placeholder="Balance value"
                      value={balValue}
                      onChange={(e) => setBalValue(e.target.value)}
                    />
                  </div>    
                </th>
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {filteredCustomers.map((row) => {
                  return (
                    <tr key={row.custId} style={{ lineHeight: '10px' }} onClick={() => handleCustDetail(row)}>
                      <td className='cell-left'><span style={{ paddingLeft: '10px' }}>{row.custId}</span></td>
                      <td ><span style={{ paddingLeft: '10px' }}>{row.custMo}</span></td>
                      <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px' }} >{row.custEName}</span></td>
                      <td colSpan='2' className="cell-left"><span style={{ paddingLeft: '10px' }}>{row.custAreaEName}</span></td>
                      <td>
                        <span style={{display: 'flex', paddingLeft: '10px'}}>
                          <span style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: row.custVerify === 'N' ? '#ff0000' : '#00962d', marginRight: '5px'}}></span>
                          <span>{row.custVerify === 'N' ? 'Pending' : 'Complete'}</span>
                        </span>
                      </td>
                      <td className="cell-right" onClick={(e) => { e.stopPropagation(); handleCustLedger(row) }}><span style={{color: Number(row.custBalance) < 0 ? 'red' : 'inherit', paddingRight: '10px' }}>{row.custBalance}</span></td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th className="cell-left"><span style={{ paddingLeft: '15px' }}>{totalCount}</span></th>
                <th className="cell-left" colSpan='5'><span style={{ paddingLeft: '10px' }}>Total</span></th>
                <th className="cell-right"><span style={{ paddingRight: '15px' }}>{totalBalance}</span></th>
              </tr>
            </tfoot>
          </table>
          

          {/* Modal for Customer Detail */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Customer Detail</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tr>
                        <td style={{ padding: '2px' }} className="cell-left">ID : {selectedCustomer.custId}</td>
                        <td style={{ padding: '2px' }} className="cell-left">
                            <a 
                              href={`whatsapp://send?phone=91${selectedCustomer.custMo}`} 
                              style={{ textDecoration: "none", color: "inherit" }}
                            >
                              Mo No : {selectedCustomer.custMo}
                            </a> 
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: '2px' }} className="cell-left">Notitication Send : </td>
                        <td style={{ padding: '2px' }} className="cell-left">
                              <span style={{display: 'flex', padding: '2px', alignItems: 'center'}}>
                                <span style={{  width: '10px', height: '10px', borderRadius: '50%', backgroundColor: selectedCustomer.custPNToken === 'android' ? '#00962d' : '#000000', marginRight: '5px', marginLeft: '10px'}}></span>
                                <span>{selectedCustomer.custPNToken === 'android' ? 'Android ' : 'ios '}</span>
                                <span style={{ marginLeft: '15px' }}>{selectedCustomer.custLang}</span>
                              </span>
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: '2px' }} className="cell-left">Ref No : </td>
                        <td style={{ padding: '2px' }} className="cell-left">{selectedCustomer.custRefno}</td>
                      </tr>
                      <tr>
                        <td className="cell-left" style={{ padding: '2px' }}> Area</td>
                        <td style={{ padding: '2px' }} className="cell-left">{selectedCustomer.custAreaEName}</td>  
                      </tr>
                      <tr>
                        <td className="cell-left" style={{ padding: "2px" }}>
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              padding: "2px",
                            }}
                          >
                            {selectedCustomer.custLoc === 'Yes'  ? (
                              /* ✅ Google Map icon */
                              <a
                                href={`https://www.google.com/maps?q=${selectedCustomer.custLocation.y},${selectedCustomer.custLocation.x}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginLeft: "10px" }}
                              >
                                <img
                                  src={gmaplogo}
                                  alt="Map"
                                  style={{ width: "18px", height: "18px", cursor: "pointer" }}
                                />
                              </a>
                            ) : (
                              /* 🔴 Red dot */
                              <span
                                style={{
                                  width: "10px",
                                  height: "10px",
                                  borderRadius: "50%",
                                  backgroundColor: "#FF0000",
                                  marginLeft: "10px",
                                }}
                              ></span>
                            )}

                            <span style={{ marginLeft: "15px" }}>Location is ok ?</span>
                          </span>
                        </td>
      
                        <td style={{ padding: '2px' }}><select
                              value={selectedCustomer.custLocStatus}
                              onChange={(e) => setSelectedCustomer({ ...selectedCustomer, custLocStatus: e.target.value })}
                            >
                              <option value="Y">Yes</option>
                              <option value="N">No</option>
                            </select>
                        </td>                      
                      </tr>
                      <tr>
                        <td style={{ padding: '0px', fontWeight: 'Bold' }}>English Name & Add</td>
                        <td style={{ padding: '0px', fontWeight: 'Bold' }}>Gujarati Name & Add</td>
                      </tr>
                      <tr>
                        <td style={{ padding: '2px', fontSize: '14px'  }}><input type="text" style={{ padding: '2px' }} value={selectedCustomer.custEName} onChange={(e) => setSelectedCustomer({ ...selectedCustomer, custEName: e.target.value })} /></td>
                        <td style={{ padding: '2px', fontSize: '14px'  }}><input type="text" style={{ padding: '2px' }} value={selectedCustomer.custName} onChange={(e) => setSelectedCustomer({ ...selectedCustomer, custName: e.target.value })} /></td>
                      </tr>
                      <tr>
                        <td><textarea style={{ width: '100%', height: '5em', fontSize: '14px'  }} value={selectedCustomer.custEAdd} onChange={(e) => setSelectedCustomer({ ...selectedCustomer, custEAdd: e.target.value })} /></td>
                        <td><textarea style={{ width: '100%', height: '5em', fontSize: '14px' }} value={selectedCustomer.custAdd} onChange={(e) => setSelectedCustomer({ ...selectedCustomer, custAdd: e.target.value })} /></td>
                      </tr>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                    <Button color="success" style={{ flex: 1, marginRight: '10px', marginBottom: '5px' }} onClick={handleUpdateCust}>
                      Update
                    </Button>
                    <Button color="primary" style={{ flex: 1, marginBottom: '5px' }} onClick={() => setModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>

          {/* Modal for Add New Customer */}
            <Modal isOpen={addmodalVisible} toggle={() => setModalVisible(!addmodalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Add New Customer</h5>  
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tr>
                        <td style={{ padding: '2px' }} className="cell-left">Mobile No.</td>
                        <td style={{ padding: '2px', fontSize: '14px'  }}><input type="text" maxLength="10" style={{ padding: '2px' }} value={addCustMo} onChange={(e) => setAddCustMo(e.target.value.replace(/[^0-9]/g, '').slice(0, 10))}/></td>
                      </tr>
                      <tr>
                        <td className="cell-left" style={{ padding: '2px' }}> Area</td>
                        <td style={{ padding: '2px' }} >
                            <select
                              value={addCustAreaID}
                              onChange={(e) => setAddCustAreaId(e.target.value)}
                            >
                              <option key={''} value={''}>Select Area</option>
                              {areas.map((area) => (
                                  <option key={area.areaId} value={area.areaId}>
                                    {area.areaEName}
                                  </option>
                              ))}
                            </select>
                        </td>    
                      </tr>
                      <tr>
                        <td style={{ padding: '0px', fontWeight: 'Bold' }}>English Name & Add</td>
                        <td style={{ padding: '0px', fontWeight: 'Bold' }}>Gujarati Name & Add</td>
                      </tr>
                      <tr>
                        <td style={{ padding: '2px', fontSize: '14px'  }}><input type="text" style={{ padding: '2px' }} value={addCustEName} onChange={(e) => setAddCustEName(e.target.value)} /></td>
                        <td style={{ padding: '2px', fontSize: '14px'  }}><input type="text" style={{ padding: '2px' }} value={addCustName} onChange={(e) => setAddCustName(e.target.value)} /></td>
                      </tr>
                      <tr>
                        <td><textarea style={{ width: '100%', height: '5em', fontSize: '14px'  }} value={addCustEAdd} onChange={(e) => setAddCustEAdd(e.target.value)} /></td>
                        <td><textarea style={{ width: '100%', height: '5em', fontSize: '14px' }} value={addCustAdd} onChange={(e) => setAddCustAdd(e.target.value)} /></td>
                      </tr>
                      <tr>
                        <td style={{ padding: '2px' }} className="cell-left">Ref No : </td>
                        <td style={{ padding: '2px', fontSize: '14px'  }}><input type="text" maxLength="10" style={{ padding: '2px' }} value={addCustRefno} onChange={(e) => setAddCustRefno(e.target.value.replace(/[^0-9]/g, '').slice(0, 10))}/></td>
                      </tr>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleAddCust}>
                      Add New
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setAddModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>  

          {/* Modal for Customer Ledger */}
            <Modal isOpen={ledgerModalVisible} toggle={() => setLedgerModalVisible(!ledgerModalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ padding: '2px' }} >Date</th>
                          <th style={{ padding: '2px' }} >Type</th>
                          <th style={{ padding: '2px' }} >Sales</th>
                          <th style={{ padding: '2px', paddingRight: '10px', }} >Pay</th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                        {ledgerData.map((row, index) => {
                            return (
                              <tr key={index} >
                                <td className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>{new Date(row.tr_date).toLocaleDateString("en-GB").replace(/\//g, "-")}</td>
                                <td className="cell-left" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >
                                    {row.tr_type === 'Cash_Back' ? (
                                      <span style={{color:'red'}}>{row.tr_type}</span>
                                    ) : (
                                        <span>{row.tr_type}</span>
                                    )}
                                </td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px'}}> <span style={{ cursor:'pointer'}} onClick={() => handleSalesDetail(row)} >{row.sl_amt === 0 ? '' : row.sl_amt}</span></td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.cr_amt === 0 ? '' : row.cr_amt}</td>
                              </tr>
                            );
                        })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th colSpan='2' className="cell-left"style={{ padding: '2px' }} >
                            <Button color="primary" style={{ padding: '2px', margin: '2px' }} onClick={() => setLedgerModalVisible(false)}>
                              Close
                            </Button>
                          </th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{ledgerData?.reduce((sum, ledger) => sum + (ledger.sl_amt || 0), 0)}</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{ledgerData?.reduce((sum, ledger) => sum + (ledger.cr_amt || 0), 0)}</th>
                        </tr> 
                      </tfoot>
                    </table>
                  </div>
              </ModalBody>
            </Modal>    

          {/* Modal for Sales Detail */}
            <Modal isOpen={salesDetailModalVisible} toggle={() => setSalesDetailModalVisible(!modalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h6>{selectedCustomer.custEName} - {new Date(selectedLedgerData.tr_date).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false,}).replace(/\//g, "-")}</h6>                
                  <div>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th colSpan='3' className="cell-left" style={{ padding: '2px' }} >Item</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >Qty</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >Amount</th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                        {selectedSalesDetail.map((row) => {
                            return (
                              <tr key={row.prd_id} style={{ cursor: 'pointer' }} >
                                <td colSpan='3' className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>{row.prd_name}</td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.sd_prd_qty}</td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.sd_prd_amt}</td>
                              </tr>
                            );
                        })}
                      </tbody> 
                      <tfoot>
                        {(selectedLedgerData.sl_amt - (selectedSalesDetail.reduce((sum, item) => sum + item.sd_prd_amt, 0)) < 0) && (
                          <tr>
                            <td colSpan='3' className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>Round off</td>
                            <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} ></td>
                            <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{selectedLedgerData.sl_amt - (selectedSalesDetail.reduce((sum, item) => sum + item.sd_prd_amt, 0))}</td>
                          </tr>
                        )}
                        <tr>
                          <th colSpan='3' className="cell-left"style={{ padding: '2px' }} >
                              <Button color="primary" style={{ padding: '2px', margin: '2px' }} onClick={() => {setSalesDetailModalVisible(false); setLedgerModalVisible(true);}}>
                                Close
                              </Button>
                          </th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{detailtotalWeight.toFixed(3)}</th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{detailtotalAmt.toFixed(0)}</th>
                        </tr> 
                      </tfoot>
                    </table>
                  </div>
              </ModalBody>
            </Modal>  

    </div>
  );
};

export default CustomerMaster;
